import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  var currentYear = new Date().getFullYear();
  return (
    <DefaultFooter
      style={{
        background: "none",
      }}
      copyright={` Copyright ${currentYear} METAX SOFTWARE PTE.LTD.`}
      links={[
        {
          key: "MetaX 策略管理平台",
          title: "MetaX 策略管理平台",
          href: "https://metaxsoft.com",
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
